<button (click)="updateControlValue('+')" mat-icon-button>
  <mat-icon>add_circle_outline</mat-icon>
</button>
<span class="mat-subtitle-2">{{ val }}</span>
<button (click)="updateControlValue('-')" mat-icon-button>
  <mat-icon>remove_circle_outline</mat-icon>
</button>